import { EXPRESS_API } from 'configs/api/expressApi';
import { useMutation, useQueryClient } from 'react-query';
import { crmIntegrationsKeys } from '../crmIntegrations/queryKeys';

interface IConnectVinSolutionUsersRequest {
  data: { vinsolutionsUserId: number; userId: number | null };
  customerId: number;
}

export const connectVinsolutionUsers = async ({
  data,
  customerId,
}: IConnectVinSolutionUsersRequest) => {
  const response = await EXPRESS_API.put(
    `/crm/vinsolutions/${customerId}/users`,
    data
  );
  return response.data;
};

export const useVinSolutionsUsersMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(connectVinsolutionUsers, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(
        crmIntegrationsKeys.vinsolutionUsers()
      );
    },
    onError: error => {
      console.log(error);
    },
  });
};
